const _ = require('lodash')
const cookie = require('js-cookie')
const validator = require('validator')
const { 'track-click': trackClickEvent } = require('client/behaviors/track')
const { track } = require('client/lib/analytics')
const Modal = require('client/components/modal')

const INPUT_SELECTOR = '.add-url__input'
const SUBMIT_SELECTOR = '.add-url__submit'
const ERROR_SELECTOR = '.add-url__error'
const TOOLTIP_SELECTOR = '.posting-add-url-first-time'
const BUTTON_TRACKING_SELECTOR = '.ExtensionPromo__button[data-track-event]'
const BOOKMARKLET_SELECTOR = '.ExtensionPromo__button--bookmarklet'
const HELP_BUTTON_SELECTOR = '.ExtensionPromo__help-button'
const HELP_SECTION_SELECTOR = '.ExtensionHelp'
const HELP_TRANSITION_CLASSNAME = 'ExtensionHelp--transition-in'
const HELP_BACK_SELECTOR = '.ExtensionHelp__back-button'

module.exports = class AddUrlModal extends Modal {
  constructor(options) {
    super(_.defaults(options, {
      modalTemplate: require('*views/modals/add-url'),
      modalClassName: 'base-modal--drawer-right add-url-modal',
      modalTitle: 'Add a Page to Mix'
    }))
    _.bindAll(this, ['onInputChange', 'onInputKeyDown', 'onSubmit'])
  }

  didRender() {
    super.didRender()
    // Cache jQuery handles
    this.$input = this.$el.find(INPUT_SELECTOR)
    this.$submit = this.$el.find(SUBMIT_SELECTOR)
    this.$error = this.$el.find(ERROR_SELECTOR)
    this.$tooltip = this.$el.find(TOOLTIP_SELECTOR)
    this.$help = this.$el.find(HELP_SECTION_SELECTOR)
    // Register event listeners
    this.$input.on('input', this.onInputChange)
    this.$input.on('keydown', this.onInputKeyDown)
    this.$el.on('submit', this.onSubmit)
    this.$el.find(BUTTON_TRACKING_SELECTOR).on('click', trackClickEvent)
    this.$el.find(BOOKMARKLET_SELECTOR).on('click', (event) => {
      event.preventDefault() // Don't run the bookmarklet, just allow dragging
    })
    if (this.$help.length) {
      this.$el.find(HELP_BUTTON_SELECTOR).on('click', (event) => {
        event.preventDefault()
        this.$help.addClass(HELP_TRANSITION_CLASSNAME)
      })
      this.$help.find(HELP_BACK_SELECTOR).on('click', (event) => {
        event.preventDefault()
        this.$help.removeClass(HELP_TRANSITION_CLASSNAME)
      })
    }
    // Setup initial state
    this.onInputChange()
    this.$input.focus()
    if (cookie.get('tutorial_add-post-tooltip')) {
      this.$tooltip.show('block')
    }
  }

  onInputChange() {
    const disabled = !this.$input.val()
    this.$submit.prop('disabled', disabled)
    this.$error.empty()
  }

  onInputKeyDown(event) {
    if (event.keyCode == 13) { // Enter
      event.preventDefault()
      this.$el.submit()
    }
  }

  onSubmit(event) {
    event.preventDefault()
    const url = this.$input.val().trim()
    if (!validateUrl(url)) {
      this.$error.text('Sorry, that looks like an invalid URL.')
      this.$input.focus()
      return
    }
    track('enter-input-url', {
      url,
      metabase: {
        'actioned_object_type': 'url',
        'actioned_object_id': url
      }
    })
    this.resolve(url)
  }
}

function validateUrl(url) {
  return validator.isURL(url || '', {
    'require_valid_protocol': false,
    'allow_protocol_relative_urls': true
  })
}
